import React from 'react';
import Profile from './Profile/Profile';
import SignDocument from './SignDocument/SignDocument';

const Sign = () => {
  return (
    <div>
      <Profile />
      <SignDocument />
    </div>
  );
};

export default Sign;